// extracted by mini-css-extract-plugin
export default {"container":"NotAuthorizedHome_container__0bk41"};